import React, { useEffect } from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feed-no-results.css";

export function FeedNoResults(): JSX.Element {
    useEffect(() => {
        analytics.event("ENGAGEMENT", "FEED_END", "EMPTY_FEED_LANDING", true);
    }, []);

    return (
        <p className={styles.wrapper}>
            {/* Sorry, no matching items found. */}
            <em>{gettext("feeds.empty_message")}</em>
        </p>
    );
}

export default FeedNoResults;
